/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetPromotionCustomerCandidates200ResponseItemsInner
 */
export interface GetPromotionCustomerCandidates200ResponseItemsInner {
    /**
     * 
     * @type {string}
     * @memberof GetPromotionCustomerCandidates200ResponseItemsInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetPromotionCustomerCandidates200ResponseItemsInner
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPromotionCustomerCandidates200ResponseItemsInner
     */
    surname?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPromotionCustomerCandidates200ResponseItemsInner
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPromotionCustomerCandidates200ResponseItemsInner
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPromotionCustomerCandidates200ResponseItemsInner
     */
    source?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPromotionCustomerCandidates200ResponseItemsInner
     */
    phoneNumberCode?: string;
    /**
     * 
     * @type {Date}
     * @memberof GetPromotionCustomerCandidates200ResponseItemsInner
     */
    creationTime?: Date;
    /**
     * 
     * @type {string}
     * @memberof GetPromotionCustomerCandidates200ResponseItemsInner
     */
    internalNote?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPromotionCustomerCandidates200ResponseItemsInner
     */
    marketingCommunication?: boolean;
}

/**
 * Check if a given object implements the GetPromotionCustomerCandidates200ResponseItemsInner interface.
 */
export function instanceOfGetPromotionCustomerCandidates200ResponseItemsInner(value: object): value is GetPromotionCustomerCandidates200ResponseItemsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetPromotionCustomerCandidates200ResponseItemsInnerFromJSON(json: any): GetPromotionCustomerCandidates200ResponseItemsInner {
    return GetPromotionCustomerCandidates200ResponseItemsInnerFromJSONTyped(json, false);
}

export function GetPromotionCustomerCandidates200ResponseItemsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPromotionCustomerCandidates200ResponseItemsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'surname': json['surname'] == null ? undefined : json['surname'],
        'email': json['email'] == null ? undefined : json['email'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'source': json['source'] == null ? undefined : json['source'],
        'phoneNumberCode': json['phoneNumberCode'] == null ? undefined : json['phoneNumberCode'],
        'creationTime': json['creationTime'] == null ? undefined : (new Date(json['creationTime'])),
        'internalNote': json['internalNote'] == null ? undefined : json['internalNote'],
        'marketingCommunication': json['marketingCommunication'] == null ? undefined : json['marketingCommunication'],
    };
}

export function GetPromotionCustomerCandidates200ResponseItemsInnerToJSON(json: any): GetPromotionCustomerCandidates200ResponseItemsInner {
    return GetPromotionCustomerCandidates200ResponseItemsInnerToJSONTyped(json, false);
}

export function GetPromotionCustomerCandidates200ResponseItemsInnerToJSONTyped(value?: GetPromotionCustomerCandidates200ResponseItemsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'surname': value['surname'],
        'email': value['email'],
        'phoneNumber': value['phoneNumber'],
        'source': value['source'],
        'phoneNumberCode': value['phoneNumberCode'],
        'creationTime': value['creationTime'] == null ? undefined : ((value['creationTime']).toISOString()),
        'internalNote': value['internalNote'],
        'marketingCommunication': value['marketingCommunication'],
    };
}

